import React from 'react';
import { Link } from 'react-router-dom';
import { FiArrowRight, FiCheck } from 'react-icons/fi';
import Reveal from './Reveal';

const points = ['Website', 'Google listing', 'Reviews', 'Social media', 'Search visibility', 'Enquiry journey'];

const AuditPromo = ({ alt = false }) => (
  <section className={`section ${alt ? 'section-alt' : ''}`}>
    <div className="container">
      <Reveal className="audit-promo">
        <div className="audit-promo-copy">
          <span className="eyebrow">Free for institutes</span>
          <h2>Get a free digital audit of your institute</h2>
          <p>
            We&rsquo;ll review how your institute looks online and send you clear, prioritised
            fixes. No cost, no obligation.
          </p>
          <ul className="audit-promo-points">
            {points.map((point) => (
              <li key={point}><FiCheck aria-hidden="true" />{point}</li>
            ))}
          </ul>
        </div>
        <Link to="/free-audit" className="btn btn-lg">
          Get my free audit <FiArrowRight />
        </Link>
      </Reveal>
    </div>
  </section>
);

export default AuditPromo;
